import { render, staticRenderFns } from "./activate-site-document-modal.vue?vue&type=template&id=a8d0f1ae&scoped=true&"
import script from "./activate-site-document-modal.vue?vue&type=script&lang=js&"
export * from "./activate-site-document-modal.vue?vue&type=script&lang=js&"
import style0 from "./activate-site-document-modal.vue?vue&type=style&index=0&id=a8d0f1ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d0f1ae",
  null
  
)

component.options.__file = "activate-site-document-modal.vue"
export default component.exports